var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
import { env, url } from '@nibfe/mkt-libs';
import { getCityInfo as maxGetCityInfo } from '@max/meituan-uni-city';
const platform = getPlatformType();
const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView, PlatformType.dpMinaWebview].includes(platform);
export default function getCityInfo(p) {
    return __awaiter(this, void 0, void 0, function* () {
        const city = {
            label: '北京',
            value: isDp ? 2 : 1
        };
        try {
            // 投放到小程序中时，优先从请求参数中获取
            if (env.miniProgram.isMiniProgram()) {
                /**
                 * @params forceSelectedCityId 强制选中城市id
                 * @params forceSelectedCityName 强制选中城市名称
                 * @description
                 * 在微信小程序里，外部页面跳转POI列表组件时，即使手动拼接了cityId=10，
                 * 也会被小程序自动拼接首页选中城市cityId=1，导致手动设置的cityId=10不生效
                 * {forceSelectedCityId} 和{forceSelectedCityName}约定了新的城市设定key，避开和小程序默认拼接逻辑的竞争
                 */
                const id = url.getQueryParam('forceSelectedCityId') || url.getQueryParam('cityId') || url.getQueryParam('cityid');
                const name = url.getQueryParam('forceSelectedCityName') || url.getQueryParam('cityName');
                if (id && name) {
                    city.value = Number(id);
                    city.label = name;
                    return city;
                }
            }
            const info = yield maxGetCityInfo({
                type: isDp ? 'dp' : 'mt',
                _wechat: {
                    _mt: {
                        sceneToken: 'dd-9cbc1c31cfbf2bba'
                    }
                }
            });
            if (info && info.id) {
                city.label = info.name;
                city.value = info.id;
                return city;
            }
            return city;
        }
        catch (err) {
            // 获取失败，把默认值返回
            return city;
        }
    });
}
